import _ from 'lodash'
import type {FunctionPropertyTypeMetadata} from '../../../../../metadata'
import type {CssColor} from '@wix/document-services-types'
import type {CssValue} from '../../constants'
import {deserializeFunction, serializeFunction} from '../utils/function'

const CSS_COLOR_FUNCTION_NAME: string = 'rgba'

const serialize = (
    val: any,
    {argsMetadata}: FunctionPropertyTypeMetadata,
    serializeValue: Function
): CssValue | undefined => {
    if (!_.isPlainObject(val)) {
        return undefined
    }

    const {red, green, blue, alpha} = val

    if (!_.isNumber(red) || !_.isNumber(green) || !_.isNumber(blue) || !_.isNumber(alpha)) {
        return undefined
    }

    const serializedRed = serializeValue(red, argsMetadata.red.types)
    const serializedGreen = serializeValue(green, argsMetadata.green.types)
    const serializedBlue = serializeValue(blue, argsMetadata.blue.types)
    const serializedAlpha = serializeValue(alpha, argsMetadata.alpha.types)

    return serializeFunction({
        name: CSS_COLOR_FUNCTION_NAME,
        args: [serializedRed, serializedGreen, serializedBlue, serializedAlpha]
    })
}

const deserialize = (
    rule: CssValue,
    {argsMetadata}: FunctionPropertyTypeMetadata,
    deserializeValue: Function
): CssColor | undefined => {
    const func = deserializeFunction(rule)
    if (!func) {
        return undefined
    }

    const {name, args} = func

    if (name !== CSS_COLOR_FUNCTION_NAME || args?.length !== 4) {
        return undefined
    }

    const red = deserializeValue(args[0], argsMetadata.red.types)
    const green = deserializeValue(args[1], argsMetadata.green.types)
    const blue = deserializeValue(args[2], argsMetadata.blue.types)
    const alpha = deserializeValue(args[3], argsMetadata.alpha.types)

    return {
        red,
        green,
        blue,
        alpha
    }
}

export default {
    serialize,
    deserialize
}
